import React from 'react';
import imag from '../StyledComponents/img/logo (11).png';
import { useNavigate, Link } from 'react-router-dom'; // Import Link from react-router-dom

function PrivacyPolicy() {
    return (
        <div className="log-in-main">
            <div className="log-in-inner">
                <div className="top">
                    <div className="top-inner">
                        <div className="logo">
                            <img src={imag} alt="Whooska Logo" className="logo-w"  />
                        </div>
                    </div>
                </div>

                {/* Privacy Policy Content */}
                <div className="privacy-policy-content">
                    <div className="privacy-policy-last-updated">
                        <strong>Last updated:</strong> December 22, 2024
                    </div>

                    <div className="privacy-policy-agreement">
                        <strong>1. Agreement to Terms</strong>
                        <div>
                            These Terms of Service represent a legally binding agreement between you and Whooska regarding your access to related services (collectively, the "Service"). By accessing the Service, you confirm that you have read and understood these Terms and agree to abide by them.
                        </div>
                    </div>

                    <div className="privacy-policy-eligibility">
                        <strong>2. Eligibility</strong>
                        <div>
                            You must be at least 18 years old to use the Service. By accessing the Service, you certify that you meet this age requirement.
                        </div>
                    </div>

                    <div className="privacy-policy-user-accounts">
                        <strong>3. User Accounts</strong>
                        <div>
                            When creating an account, you must provide accurate, complete, and current information. Failure to comply with this requirement may lead to immediate account termination.
                        </div>
                    </div>

                    <div className="privacy-policy-past-results">
                        <strong>4. Past Results and Future Results</strong>
                        <div>
                            In horse racing and sports betting, there are never any assurances that profits will be realised. Your betting outcomes may fluctuate, either positively or negatively, compared to the results featured on this platform, influenced by the range of betting opportunities you pursue. Additionally, the betting odds you can achieve from betting agencies and totes will also impact profits.
                            The accuracy of results shared on our website are based on results previously realised on the discord community chat and Twitter/X page shared with members / followers.
                            Membership packages may change over time, and such changes do not entitle members to refunds or alterations to their membership fees.
                            Memberships are strictly non-transferable, regardless of performance, staff changes, or personal decisions. The membership you purchase is the exact membership provided.
                            If you choose to cancel your membership, you will not receive a refund for any remaining time and will continue to have access to the tips package purchased.
                        </div>
                    </div>

                    <div className="privacy-policy-racing-tips">
                        <strong>5. Racing Tips and Packages</strong>
                        <div>
                            Whooska will aim to provide Melbourne, Brisbane, and Sydney-based tips for all race days on Saturdays for individual and monthly packages. However, based on weather, track conditions, and horse fields, tips may not be provided where tips are not deemed to be profitable with a high level of confidence to protect the brand and image of Whooska. At Whooska, we do not want to provide tips for the sake of providing tips. Generally, you will receive a full set of tips but reserve the right not to provide tips for all races.
                        </div>
                    </div>

                    <div className="privacy-policy-prohibited-activities">
                        <strong>6. Prohibited Activities</strong>
                        <div>
                            You are prohibited from:
                            <ul>
                                <li>Using the Service for illegal purposes or in violation of applicable laws.</li>
                                <li>Harassing or threatening other users.</li>
                                <li>Impersonating another user or individual.</li>
                                <li>Posting any unlawful or objectionable content.</li>
                            </ul>
                        </div>
                    </div>

                    <div className="privacy-policy-intellectual-property">
                        <strong>7. Intellectual Property</strong>
                        <div>
                            The content and services are the exclusive property of Whooska and its licensors. They are protected under copyright, trademark, and other relevant laws.
                        </div>
                    </div>

                    <div className="privacy-policy-termination">
                        <strong>8. Termination</strong>
                        <div>
                            We reserve the right to discontinue services or revoke your access to information to racing tips with or without notice if terms of usage or any other items are violated as stipulated.
                        </div>
                    </div>

                    <div className="privacy-policy-limitation">
                        <strong>9. Limitation of Liability</strong>
                        <div>
                            Whooska, along with its affiliates, is not liable for any indirect, incidental, special, consequential, or punitive damages arising from your access to or use of the Service.
                        </div>
                    </div>

                    <div className="privacy-policy-disclaimer">
                        <strong>10. Disclaimer</strong>
                        <div>
                            Your use of the Service is at your own risk. The Service is provided on an "AS IS" and "AS AVAILABLE" basis, without any warranties.
                        </div>
                    </div>

                    <div className="privacy-policy-governing-law">
                        <strong>11. Governing Law</strong>
                        <div>
                            These Terms shall be governed by the laws of Victoria / Australia, without regard to its conflict of law provisions.
                        </div>
                    </div>

                    <div className="privacy-policy-changes">
                        <strong>12. Changes to Terms</strong>
                        <div>
                            We reserve the right to modify these Terms at any time. Notice of changes will be posted on this page.
                        </div>
                    </div>

                    <div className="privacy-policy-contact">
                        <strong>13. Contact Us</strong>
                        <div>
                            For any questions regarding these Terms, please contact us at: info@whooska.com.au
                        </div>
                    </div>
                </div>

                {/* Bottom Content */}
                <div className="bottom">
                    <div className="bottom-inner">
                        <div className="text-content">
                            <div className="copy">copyright @ WhooshkaTips</div>
                            <div className="text">
                                This page is for 18+ only. Gamble Responsibly. Visit{" "}
                                <span>www.gamblinghelponline.org.vic.au</span> or call <br />
                                Gambling Help on <span>1800 858 858</span> The chances are you are about to lose
                            </div>
                            <div className="policy-container">
                                <div className="policy">

                                    <Link to="/whooska/admin/Privacy/Policy">Privacy Policy</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PrivacyPolicy;
